import { CheckCircle2 } from "lucide-react";

const highlights = [
  "Production Shows, Cabaret, Characters, Media & Installations",
  "Efficient Installation Team & Ongoing Support",
];

export const HighlightsBottom = () => {
  return (
    <section className="py-8 bg-[#0A0A0A]">
      <div className="max-w-2xl mx-auto px-6">
        <ul className="grid sm:grid-cols-2 gap-3" data-testid="hero-highlights-bottom">
          {highlights.map((h) => (
            <li key={h} className="flex flex-col items-center justify-center gap-2 text-center bg-[#121212] border border-white/10 rounded-xl px-4 py-4">
              <CheckCircle2 size={18} className="text-[#D4AF37] shrink-0" />
              <span className="text-base font-medium text-white">{h}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HighlightsBottom;
